import { Header, InboundWebhook } from 'postmark/dist/client/models';
import { TimestampDetails } from '../entity';
import { Attachment } from '../shared/attachment';
import { WidgetActionType } from '../dashboards/widget/widget.enum';
import { InboundEmailFilters } from './inbound.email.filters';
import { ImportType } from './inbound.email.configuration';
import { InboundEmailStatus } from './inbound.email.status';

export interface InboundEmail extends TimestampDetails {
    _id: string;
    status: InboundEmailStatus;
    email: PostmarkEmail;
    processedDate?: Date;
    errors?: string[];
    attachments?: EmailAttachments[];
    importType?: ImportType;
}

export interface InboundEmailCreateRequest {
    email: InboundWebhook;
}

export interface InboundEmailCreateMessage {
    inboundEmail: InboundEmail;
}

export interface PostmarkEmail {
    from: string;
    fromName: string;
    fromFull: FullContact;
    to: string;
    toFull: FullContact[];
    cc: string;
    ccFull: FullContact[];
    bcc: string;
    bccFull: FullContact[];
    replyTo: string;
    originalRecipient: string;
    subject: string;
    emailDate: Date;
    mailboxHash: string;
    tag: string;
    messageId: string;
    messageStream: string;
    rawEmail: string;
    textBody: string;
    htmlBody: string;
    strippedTextReply: string;
    headers: Header[];
    isEmailPainText: boolean
}

export interface FullContact {
    name: string;
    email: string;
    mailboxHash: string;
}

export interface EmailAttachments extends Attachment {
    inlineAttachment: boolean;
    fileType: string;
    contentId?: string;
}

export enum InboundEmailEntityFormAction {
    ReceivePostmarkEmail = 'ReceivePostmarkEmailCommand',
    ReprocessEmail = 'ReprocessEmailCommand',
    BulkReprocessEmails = 'BulkReprocessEmailsCommand',
    ProcessWith = 'ProcessWithCommand',
    WidgetData = 'WidgetDataCommand',
    DeleteEmails = 'DeleteEmailsCommand',
    BulkDeleteEmails = 'BulkDeleteEmailsCommand',
    DeleteEmail = 'DeleteEmailCommand'
}

export interface WidgetDataCountResponse {
    _id: string;
    value: number
}
export interface WidgetDataChartResponse {
    _id: InboundEmailStatus;
    value: number
}

export type InboundEmailEntityCommandRequest =
    {
        commandId: 'ReceivePostmarkEmailCommand',
        data: InboundEmailCreateRequest
    }
    | {
        commandId: 'ReprocessEmailCommand',
        data: InboundEmail
    }
    | {
        commandId: 'ProcessWithCommand',
        data: {
            inboundEmail: InboundEmail;
            inboundEmailConfiguration: any;
        }
    }
    | {
        commandId: 'WidgetDataCommand',
        data: {
            field: string;
            actionType: WidgetActionType;
            viewId?: string;
            filters?: InboundEmailFilters;
        }
    }
    | {
        commandId: 'BulkReprocessEmailsCommand',
        data: InboundEmail[]
    }